/* global localStorage */
import React from 'react'
import { connect } from 'react-redux'
import { remove } from '../actions/tokens'
import timeago from '../lib/timeago'
import dateformat from 'dateformat'

@connect(null)
export default class extends React.Component {
  state = {
    current: localStorage.getItem('accessToken') === this.props.token.token
  }

  onRevoke = (e) => {
    e.preventDefault()
    const {dispatch, token} = this.props
    dispatch(remove(token))
  }

  render () {
    const {token} = this.props

    return <tr>
      <td>
        <div>{token.name}</div>
      </td>
      <td>
        {token.last_used
          ? <span title={dateformat(token.last_used)}>
            {timeago(token.last_used, true)}
          </span>
            : <em>Never</em>
        }
      </td>
      <td>
        {token.token}
      </td>
      <td>
        {!this.state.current &&
          <a role='button' onClick={this.onRevoke} className='text-danger'>Revoke</a>
        }
      </td>
    </tr>
  }
}



// WEBPACK FOOTER //
// ./app/components/ApiToken.js